<template>
  <Modal size="lg">
    <div class="modal-header">{{ "reserve_order" | translate }}</div>
    <div class="modal-body">
      <div class="alert alert-warning" v-if="validationError">{{ validationError }}</div>

      <div class="row mb-3">
        <div class="col-3">{{ "vendor" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="reserveOrderItem.vendor"
            :placeholder="'vendor' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "order_num" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="reserveOrderItem.orderNumber"
            :placeholder="'order_num' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "quantity" | translate }}</div>
        <div class="col-9">
          <input
            type="number"
            class="form-control"
            v-model.number="reserveOrderItem.quantity"
            :placeholder="'quantity' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "amount" | translate }}</div>
        <div class="col-6">

          <div class="input-group">
            <input
              type="number"
              class="form-control"
              v-model.number="reserveOrderItem.amount"
              :placeholder="'amount' | translate"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-success" type="button"
                      @click="calculateTotal" 
              >
                <i class="fa fa-fw fa-calculator"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-3">
          <currency-picker class="form-control" v-model="reserveOrderItem.currency"></currency-picker>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "ship_to" | translate }}</div>
        <div class="col-3">
          <input
            type="text"
            class="form-control"
            v-model="reserveOrderItem.shipTo"
            :placeholder="'ship_to' | translate"
          />
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            v-model="reserveOrderItem.shippingAddress"
            :placeholder="'address' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "comment" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="reserveOrderItem.comment"
            :placeholder="'comment' | translate"
          />
        </div>
      </div>

      <part-transaction-list
        :entity="'payment' | translate"
        :transactions="reserveOrderItem.payments"
        :currency="reserveOrderItem.currency"
        :total="reserveOrderItem.amount"
      ></part-transaction-list>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">{{ "cancel" | translate }}</button>
      <button class="btn btn-primary" @click="save">{{ "save" | translate }}</button>
    </div>
  </Modal>
</template>

<script>
import _ from "lodash";
import PartTransactionList from "./PartTransactionList";
import almostEqual from "@/lib/almostEqual";
export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      reserveOrderItem: {
        currency: null,
        vendor: null,
        quantity: null,
        amount: null,
        orderNumber: null,
        shipTo: null,
        shippingAddress: null,
        payments: [
          {
            account: null,
            amount: null,
            currency: null,
          },
        ],
        comment: null,
        timestamp: new Date().getTime(),
      },
    };
  },
  created() {
    if (this.editingItem) {
      this.reserveOrderItem = _.cloneDeep(this.editingItem);
    }
  },
  methods: {
    cancel() {
      this.$emit("dismiss");
    },
    save() {
      let item = this.reserveOrderItem;
      this.assert(item.currency, "currency is required");
      this.assert(item.vendor, "vendor is required");
      this.assert(item.quantity, "quantity is required");
      this.assert(item.amount, "amount is required");
      this.assert(item.orderNumber, "order number is required");
      this.assert(item.shipTo, "ship to is required");
      this.assert(item.shippingAddress, "shipping address is required");
      this.assert(item.payments && item.payments.length, "payment is required");
      this.assert(
        almostEqual(
          item.payments.reduce(
            (sum, p) => (p.amount ? p.amount + sum : sum),
            0
          ),
          item.amount
        ),
        "payment sum shall equal total amount"
      );

      this.$emit("close", this.reserveOrderItem);
    },
    fillRemaining(payment) {
      payment.amount = 0;
    },

    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
      this.validationError = null;
    },

    calculateTotal() {
      if (!this.reserveOrderItem.payments) {
        this.reserveOrderItem.amount = 0 
        return
      }
      
      let sum = this.reserveOrderItem.payments.reduce((preSum, item) => preSum + item.amount, 0)
      this.reserveOrderItem.amount = sum
    }
  },
  components: { PartTransactionList },
};
</script>
